import {AvailableBalance} from "../../utils/creditService";
import HomeDrawCreditFormWallet from "../forms/HomeDrawCreditFormWallet";

interface HomeDrawCreditModalViewWalletProps {
  onCloseModal: () => void;
  handleBack: () => void;
  creditLine: AvailableBalance
}

function HomeDrawCreditModalViewWallet(
  {
    onCloseModal,
    handleBack,
    creditLine,
  }:HomeDrawCreditModalViewWalletProps) {
  return (

    <HomeDrawCreditFormWallet
      onCloseModal={onCloseModal}
      handleBack={handleBack}
      creditLine={creditLine}
    />

  );
}

export default HomeDrawCreditModalViewWallet;